import { compressToEncodedURIComponent, decompressFromEncodedURIComponent } from 'lz-string';

/**
 * Compresses/encodes the given object into an ASCII string encoded in Base64 suitable for use in a URL
 * @param obj - the object to compress/encode
 * @returns the compressed/encoded string
 */
export function compressObjectToEncodedURIComponent(obj: any) {
  return compressToEncodedURIComponent(JSON.stringify(obj));
}

/**
 * Decompresses/decodes the given URI component(Base64 encoded string) into an object
 * @param compressed - the string to decompress/decode
 * @returns the decompressed/decoded object
 * @throws if the input cannot be decompressed or parsed into an object
 */
export function decompressEncodedURIComponentIntoObject<TResult>(compressed: string) {
  const decompressed = decompressFromEncodedURIComponent(compressed.trim());
  if (!decompressed) {
    throw new Error('decompression failed');
  }

  try {
    return JSON.parse(decompressed) as TResult;
  } catch {
    throw new Error('parse to object failed');
  }
}
